import { UserSessionContext } from 'components/UserSession';
import { useContext, useMemo } from 'react';
import { stringifyUrl } from 'query-string';

declare global {
  interface Window {
    hostName: string;
  }
}

const useEncodedMeetupUrl = (bookingUrl: string) => {
  const { userSession } = useContext(UserSessionContext);
  return useMemo(() => stringifyUrl({
    url: bookingUrl ?? '',
    query: {
      attendee: window.btoa(unescape(encodeURIComponent(JSON.stringify(userSession)))),
      uniqueToken: userSession?.authToken ?? '',
      hostName: window.hostName,
    },
  }), [bookingUrl, userSession]);
};

export default useEncodedMeetupUrl;
